import React from "react";
import { Calendar, Clock, MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "The Date",
  description: "Saturday, June 14th, 2026. We kindly invite you to join us as we begin our forever on a beautiful summer afternoon.",
  icon: Calendar
}, {
  title: "The Time",
  description: "Ceremony begins at 4:00 PM. Please arrive early to enjoy the garden music, a glass of wine, and find your preferred seating.",
  icon: Clock
}, {
  title: "The Venue",
  description: "The Grand Conservatory. A glass-walled sanctuary surrounded by blooming gardens and timeless architecture.",
  icon: MapPin
}];
export default function TheNeighborlyAdvantage() {
  return <section data-section-id="223484" id="the-celebration-highlights" className="w-full bg-background text-foreground py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-3xl bg-primary/5 px-6 py-16 md:px-12 md:py-20 lg:px-16">
          <div className="mx-auto mb-16 max-w-2xl text-center">
            <h2 className="font-default text-3xl font-light tracking-widest text-foreground md:text-5xl uppercase">
              The Celebration Highlights
            </h2>
            <p className="mt-4 text-lg font-default text-muted-foreground italic">
              Essential details for our cherished guests as we celebrate our union.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            const isMiddle = i === 1;
            return <Card key={i} data-index={i} className={`group border-2 border-transparent bg-card transition-all duration-500 hover:border-primary/20 ${isMiddle ? 'shadow-lg -translate-y-1' : 'shadow-sm'}`}>
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-lg bg-background text-foreground transition-transform duration-300 ease-out group-hover:scale-110">
                      <Icon className="h-8 w-8 stroke-[1]" />
                    </div>
                    <CardTitle className="font-default text-sm font-medium tracking-widest uppercase text-foreground">
                      <h3>{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed text-muted-foreground font-serif text-lg">
                      {item.description}
                    </p>
                    <div className="mt-6 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                      <a href="/TheBigDayPage" className="text-xs font-default font-semibold tracking-widest uppercase border-b border-foreground pb-1">
                        View Map
                      </a>
                    </div>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}